(function (root) {
  'use strict';
  const PROPERTY = '_tier_discount_eligible';
  function formEligible(form) {
    const node = form.querySelector('[data-aerre-tier-variants]');
    if (!node) return false;
    const selected = String(form.elements.namedItem('id')?.value || '');
    if (!selected) return false;
    for (const key of ['_aerre_threshold_gift', '_aerre_rewards_gift']) {
      if (form.elements.namedItem(`properties[${key}]`)?.value) return false;
    }
    let ids;
    try { ids = JSON.parse(node.textContent); } catch (_) { return false; }
    if (Array.isArray(ids) && ids.some(id => String(id) === selected)) return true;
    const controller = root.AerreBundles?.controllers?.get(form.getAttribute('id'));
    return Boolean(controller?.usingBundle && controller.state?.configured &&
      selected === String(controller.state.bundle?.id) && root.AerreBundles.bundleAllowed(controller.state));
  }
  function syncForm(form, formData) {
    const input = form?.querySelector?.('[data-aerre-tier-property]');
    if (!input) return;
    const eligible = formEligible(form);
    input.value = 'true';
    input.disabled = !eligible;
    if (formData) {
      if (eligible) formData.set(`properties[${PROPERTY}]`, 'true');
      else formData.delete(`properties[${PROPERTY}]`);
    }
  }
  const api = { PROPERTY, formEligible, syncForm };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root.document) return;
  root.AerreTierEligibility = api;
  root.document.addEventListener('submit', event => syncForm(event.target), true);
  root.document.addEventListener('formdata', event => syncForm(event.target, event.formData), true);
  root.document.addEventListener('variant:changed', event => syncForm(event.target));
  root.document.querySelectorAll('form').forEach(form => syncForm(form));
})(typeof window === 'undefined' ? globalThis : window);
